import { html } from "htm/preact";
import { describeRoundRules } from "../../../shared/leaderboard.js";
import type { Player, Round, TeeSet } from "../../../shared/types.js";

/**
 * `teeSet` is what makes the rules say "across 9 holes" on a nine-hole course. Optional
 * because a round can be looked at before a course is picked, and because the rules are
 * still worth showing when the course hasn't loaded — without it the text falls back to
 * assuming eighteen, which is what it always used to do.
 */
export function RulesPanel({
  round,
  players,
  teeSet,
}: {
  round: Round;
  players: Player[];
  teeSet?: TeeSet;
}) {
  const rules = describeRoundRules(round, players, teeSet);
  return html`
    <div class="card m-0">
      <span class="eyebrow">${round.name} — rules</span>
      <ul class="rule-list">
        ${rules.map((line, i) => html`<li key=${i}>${line}</li>`)}
      </ul>
    </div>
  `;
}
